export function getConfiguration() {
  return {
    clientId: process.env.REACT_APP_OPENID_CLIENT_ID || '',
    redirectUri: process.env.REACT_APP_OPENID_REDIRECT_URI || '',
    silentRedirectUri: process.env.REACT_APP_OPENID_SILENT_REDIRECT_URI || '',
    scope: process.env.REACT_APP_OPENID_SCOPE || '',
    authority: process.env.REACT_APP_OPENID_AUTHORITY || '',
    authorityConfiguration: {
      authorizationEndpoint: process.env.REACT_APP_OPENID_AUTHORIZATION_ENDPOINT || '',
      tokenEndpoint: process.env.REACT_APP_OPENID_TOKEN_ENDPOINT || '',
      userinfoEndpoint: process.env.REACT_APP_OPENID_USER_INFO_ENDPOINT || '',
      endSessionEndpoint: process.env.REACT_APP_OPENID_END_SESSION_ENDPOINT || '',
      revocationEndpoint: process.env.REACT_APP_OPENID_REVOCATION_ENDPOINT || '',
      checkSessionIframe: process.env.REACT_APP_OPENID_CHECK_SESSION_IFRAME || '',
      issuer: process.env.REACT_APP_OPENID_ISSUER || '',
    },
    refreshTimeBeforeTokensExpirationInSecond: parseInt(
      process.env.REACT_APP_OPENID_REFRESH_TIME_BEFORE_TOKENS_EXPIRATION_IN_SECOND || '0',
      10
    ),
    serviceWorkerRelativeUrl: process.env.REACT_APP_OPENID_SERVICE_WORKER_RELATIVE_URL || '',
    serviceWorkerOnly: Boolean(process.env.REACT_APP_OPENID_SERVICE_WORKER_ONLY || ''),
  }
}
